import React, { useState, useEffect } from 'react'

function DatePicker(props) {
	const [date, setDate] = useState()

	useEffect(() => {
		formatDisplay(props.value)
	}, [props.value])

	const formatDisplay = (value) => {
		if(value == null || value == "") {
			setDate('MM / DD / YYYY')
			return
		}
		const dt = new Date(value)
		const d = (dt.getDate().toString().length == 1)? `0${dt.getDate()}`: dt.getDate()
		const m = (`${dt.getMonth()+1}`.length == 1)? `0${dt.getMonth()+1}`: dt.getMonth()+1
		const dFormat = `${m} / ${d} / ${dt.getFullYear()}`
		setDate(dFormat)
	}

	return(<div className='date-picker'><div>
		<input type='text' value={date} placeholder='MM / DD / YYYY' disabled={props.disabled} />
		<input type='date' name={props.name} max={props.max} min={props.min} value={props.value}
			onChange={(e) => {
				formatDisplay(e.target.value)
				props.onChange(e.target.value)
			}
		} disabled={props.disabled} />
		</div>
	</div>)
}

export default DatePicker
